import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.number.is-integer";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.number.constructor";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { check, Match } from 'meteor/check';
import { Accounts } from 'meteor/accounts-base';
import { Email } from 'meteor/email'; // import { TransactionalEmailsApi, SendSmtpEmail } from '@getbrevo/brevo'
// import { getMeazure } from './my-functions'
// import introductie from '../assets/introductie.json'
// var Users = new Mongo.Collection('users', {idGeneration: 'MONGO'})

export var Tasks = new Mongo.Collection('tasks');
export var Measures = new Mongo.Collection('measures', {
  idGeneration: 'MONGO'
}); // export const Gebied = new Mongo.Collection('gebied', { idGeneration: 'MONGO' })

export var Notices = new Mongo.Collection('notices');
export var Adverts = new Mongo.Collection('adverts');
export var Images = new Mongo.Collection('images');
export var Polygons = new Mongo.Collection('polygons');
export var UserData = new Meteor.Collection('userData');
export var Logs = new Meteor.Collection('logs', {
  idGeneration: 'MONGO'
});
export var MailErrors = new Meteor.Collection('mailErrors', {
  idGeneration: 'MONGO'
});
export var Land = new Mongo.Collection('land', {
  idGeneration: 'MONGO'
});
export var KV = new Mongo.Collection('KV', {
  idGeneration: 'MONGO'
});
export var introductieContentName = 'introductie';
export var locationContentName = 'location';
import { sanitizeNewUserProfile, isValidOrganization } from "./owners/rules";
import { isAcceptedName, NAME_MAX_LENGTH, TITLE_MAX_LENGTH, MESSAGE_TITLE_MAX_LENGTH, LINK_MAX_LENGTH, POLL_OPTION_MAX_LENGTH, POLL_OPTIONS_MAX } from "./core/limits";
import { UNPUBLISHED_KV_KEYS } from "./core/kv";
import { runHook } from "./core/hooks"; // the texts shown as HTML, cleaned on save (#524)

import { cleanHtml, escapeText } from "./core/html";
import { SHAPE_LIMITS, geometryRejectReason, withoutRepeatedPositions } from "./polygons/shapeRules";
import { mongoRejectReason } from "./polygons/mongoShape";
import { validLevel } from "./geometry/checks";
import { isAdmin } from "./core/roles";
import { requireCommunityRole } from "./community/access";
import { publicSettings } from "./core/settings";

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function replaceAll(str, find, replace) {
  // a function: a '$&' or "$'" in the text stays as typed
  return str.replace(new RegExp(escapeRegExp(find), 'g'), function () {
    return replace;
  });
} // a post (thread) and its community, by the post's id; not found: an error (#18)


function findThread(threadId) {
  requireLogin();
  check(threadId, String);
  var land = Land.findOne({
    'threads.id': threadId
  });
  var thread = land && land.threads.find(function (item) {
    return item.id === threadId;
  });
  if (!thread) throw new Meteor.Error('not-found', 'No such post');
  return {
    land: land,
    thread: thread
  };
} // a pledge, treasure, meeting, message, poll or Polis conversation (its list: 'pledges', 'treasures', 'meetings',
// 'messages', 'polls', 'polis') and its community, by its id; not found: an error (#18)


function findItem(list, itemId) {
  requireLogin();
  check(itemId, String);
  var land = Land.findOne(_defineProperty({}, list + '.id', itemId));
  var item = land && (land[list] || []).find(function (entry) {
    return entry.id === itemId;
  });
  if (!item) throw new Meteor.Error('not-found', NOT_FOUND[list]);
  return {
    land: land,
    item: item
  };
}

var NOT_FOUND = {
  pledges: 'No such pledge',
  treasures: 'No such treasure',
  meetings: 'No such meeting',
  messages: 'No such message',
  polls: 'No such poll',
  polis: 'No such Polis conversation'
}; // a member's answer to a meeting's invitation (list 'accepted' or 'rejected'): once, and the other answer taken back (#18)

function answerInvite(meetingId, list, other) {
  var _findItem = findItem('meetings', meetingId),
      land = _findItem.land;

  var user = requireCommunityRole('member', land);
  Land.update({
    id: land.id,
    'meetings.id': meetingId
  }, {
    $addToSet: _defineProperty({}, 'meetings.$.' + list, user._id),
    $pull: _defineProperty({}, 'meetings.$.' + other, user._id)
  });
} // the most one answer may pledge (src/pages/PledgePage.vue maxPledge)


var MAX_PLEDGE_AMOUNT = 9999999; // how long a treasure's reports may grow together

var REPORT_TEXT_MAX = 20000; // what a treasure says, as its wizard sends it (more fields may come along; these are the ones stored): a title (the
// wizards stop at TITLE_MAX_LENGTH; room for older texts), the text as HTML, a place

var shortText = Match.Where(function (value) {
  return typeof value === 'string' && value.length <= 200;
});
var longText = Match.Where(function (value) {
  return typeof value === 'string' && value.length <= 100000;
}); // the limits of the forms (core/limits.js): a meeting's title, its link as typed (the form shows https:// in front; room
// for one typed anyway), a message's title

var textUpTo = function textUpTo(max) {
  return Match.Where(function (value) {
    return typeof value === 'string' && value.length <= max;
  });
};

var meetingTitle = textUpTo(TITLE_MAX_LENGTH);
var linkText = textUpTo(LINK_MAX_LENGTH + 'https://'.length);
var messageTitle = textUpTo(MESSAGE_TITLE_MAX_LENGTH); // a text that must say something: a poll's question, an answer

var filledText = function filledText(max) {
  return Match.Where(function (value) {
    return typeof value === 'string' && value.trim().length > 0 && value.length <= max;
  });
};

var ITEM_DATA = Match.ObjectIncluding({
  title: shortText,
  description: longText,
  geometry: Match.Optional(Object)
}); // a pledge's: also its kind and its goal (the wizard's maxGoal)

var PLEDGE_DATA = Match.ObjectIncluding({
  title: shortText,
  description: longText,
  geometry: Match.Optional(Object),
  type: Match.Optional(shortText),
  goal: Match.Optional(Match.Where(function (value) {
    return value === '' || value === null || isFinite(Number(value)) && Number(value) >= 0 && Number(value) <= 999999999;
  }))
}); // a comment, its post and its community, by their ids; the comment must be the post's (#18)

function findComment(commentId, threadId) {
  check(commentId, String);

  var _findThread = findThread(threadId),
      land = _findThread.land,
      thread = _findThread.thread;

  var comment = (thread.comments || []).find(function (item) {
    return item.id === commentId;
  });
  if (!comment) throw new Meteor.Error('not-found', 'No such comment');
  return {
    land: land,
    thread: thread,
    comment: comment
  };
} // a vote on a comment: a member's, never on their own comment (#18); returns the user


function requireVoter(land, comment) {
  var user = requireCommunityRole('member', land);
  if (comment.createdBy === user._id) throw new Meteor.Error('not-authorized', 'No vote on your own comment');
  return user;
} // the logged-in user's id, else an error


function requireLogin() {
  if (!Meteor.userId()) throw new Meteor.Error('not-authorized', 'Login required');
  return Meteor.userId();
} // one comment changed in place: reading the list and writing it back lost what others wrote meanwhile (#18).
// modifierAt(path) gets the comment's path ('threads.2.comments.5'); the update holds only while the comment is still
// at that place (a post or comment removed meanwhile moves it: read again). Meteor 1.8 drops arrayFilters.


function updateComment(commentId, threadId, modifierAt) {
  for (var attempt = 0; attempt < 3; attempt++) {
    var land = Land.findOne({
      'threads.id': threadId
    }, {
      fields: {
        'id': 1,
        'threads.id': 1,
        'threads.comments.id': 1
      }
    });
    var t = land ? land.threads.findIndex(function (item) {
      return item.id === threadId;
    }) : -1;
    var c = t === -1 ? -1 : (land.threads[t].comments || []).findIndex(function (item) {
      return item.id === commentId;
    });
    if (c === -1) throw new Meteor.Error('not-found', 'No such comment');
    var path = 'threads.' + t + '.comments.' + c;
    if (Land.update(_defineProperty({
      id: land.id
    }, path + '.id', commentId), modifierAt(path))) return;
  }

  throw new Meteor.Error('busy', 'The post changed meanwhile, try again');
}

""; // non-enumerable, so for..in over arrays (Leaflet's polygonCenter) doesn't see them

Object.defineProperty(Array.prototype, 'remove', {
  configurable: true,
  writable: true,
  value: function value() {
    var what,
        a = arguments,
        L = a.length,
        ax;

    while (L && this.length) {
      what = a[--L];

      while ((ax = this.indexOf(what)) !== -1) {
        this.splice(ax, 1);
      }
    }

    return this;
  }
});
Object.defineProperty(Array.prototype, 'shuffle', {
  configurable: true,
  writable: true,
  value: function value() {
    for (var i = this.length - 1; i > 0; i--) {
      var rand = Math.floor(Math.random() * (i + 1));
      var _ref = [this[rand], this[i]];
      this[i] = _ref[0];
      this[rand] = _ref[1];
    }
  }
});

var genUuid = function genUuid() {
  var s = [];
  var hexDigits = '0123456789abcdef';

  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }

  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

  s[8] = s[13] = s[18] = s[23] = '-';
  var uuid = s.join('');
  return uuid;
}; // Sends an HTML mail (production only; elsewhere it is logged). A plain function, not a Meteor method (#249): as a method
// any browser could send any mail from any sender through the app's mail account. Server code only: in a method's
// simulation in the browser it does nothing


export var sendHtmlEmail = function sendHtmlEmail(to, from, subject, html) {
  if (Meteor.isClient) return;
  html = '<!DOCTYPE html><html lang="en"><head> <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' + html + '</head></html>';
  console.log('CALLED: sendHtmlEmail => ' + to); // Make sure that all arguments are strings.

  check([to, from, subject, html], [String]); // let text = 'bla die bla bla MVD test'

  /*console.log('EMAIL ADRESS')
  console.log(to)
  console.log('EMAIL SUBJECT')
  console.log(subject)
  console.log('EMAIL html')
  console.log(html)*/

  var bcc = 'friends@greenmapper.org';
  var currentEnv = publicSettings().environment;

  if (currentEnv === 'prod') {
    // Sent in the background: the caller (e.g. sign-up in Accounts.onCreateUser) never waits for the mail server.
    // When the mail server cannot be reached, sending used to block the caller until the SMTP connection timed
    // out and then made it fail, so nobody could register (hotfix, 3 Oct 2026). A failed mail is only logged.
    Meteor.defer(function () {
      try {
        Email.send({
          to: to,
          bcc: bcc,
          from: from,
          subject: subject,
          html: html
          /*,text*/

        });
      } catch (e) {
        console.log('sendHtmlEmail to ' + to + ' failed: ' + e.message);
      }
    });
  } else {
    console.log('Email.send DENIED: ' + currentEnv);
  }
}; // import { WebApp } from 'meteor/webapp'

if (Meteor.isServer) {
  // the mail server (its password included) is set from the server-only settings: core/server/mail.js (#9)
  var Extensions = require('websocket-extensions'),
      deflate = require('permessage-deflate'),
      zlib = require('zlib');

  deflate = deflate.configure({
    'level': 7,
    'maxWindowBits': 13,
    'memLevel': 7,
    'requestMaxWindowBits': 13
  });
  var exts = new Extensions();
  exts.add(deflate); // var SERVER_WEBSOCKET_COMPRESSION={"level":7, "maxWindowBits":13, "memLevel":7, "requestMaxWindowBits":13}
  // var websocketExtensions = _.once(function () {
  //     console.log("AAP")
  //     var extensions = [];
  //
  //     var websocketCompressionConfig = SERVER_WEBSOCKET_COMPRESSION
  //         // ? JSON.parse(process.env.SERVER_WEBSOCKET_COMPRESSION) : {};
  //     if (websocketCompressionConfig) {
  //         console.log("AAP3")
  //         extensions.push(Npm.require('permessage-deflate').configure(
  //             websocketCompressionConfig
  //         ));
  //     }
  //
  //     return extensions;
  // });

  WebApp.rawConnectHandlers.use(function (req, res, next) {
    res.setHeader('Access-Control-Allow-Origin', '*');
    res.setHeader('Access-Control-Allow-Headers', 'Authorization,Content-Type');
    return next();
  });
  /*Router.route('/logs/:id', { where: 'server' }).get(function () {
      var userId = this.params.id;
       // var response = Meteor.call('_logs')
       let logs = Logs.find({user:userId}).fetch()
      console.log('\x1b[32m%s\x1b[0m', '_logs method called')
      console.log('\x1b[32m%s\x1b[0m', logs.length)
       const response = {
          status: 200,
          message: 'this is a server response :)'
      }
       this.response.setHeader('Content-Type', 'application/json')
      this.response.end(JSON.stringify(response))
  })*/

  Accounts.onCreateUser(function (options, user) {
    // console.log('----------------------Accounts.onCreateUser --------------------------------')
    var userToCreate = Object.assign({
      createdAt: new Date()
    }, user);

    if (options.profile) {
      // owners always start as pending (owners/rules.js)
      userToCreate.profile = sanitizeNewUserProfile(options.profile, userToCreate.createdAt);
      if (!isAcceptedName(userToCreate.profile.name)) throw new Meteor.Error('invalid-name', 'The name must be text of at most ' + NAME_MAX_LENGTH + ' characters');
      if (userToCreate.profile.name) userToCreate.profile.name = userToCreate.profile.name.trim();

      if (userToCreate.profile.owner === true) {
        if (!isValidOrganization(userToCreate.profile.organization)) throw new Meteor.Error('organization-required', 'Owners must name their organisation');
        userToCreate.profile.organization = userToCreate.profile.organization.trim();
      }
    } // console.log('user', userToCreate)
    // console.log('user.profile', userToCreate.profile)


    var template = userToCreate.profile.owner ? KV.findOne({
      'key': 'REGISTERED_WELCOME_OWNER'
    }) : KV.findOne({
      'key': 'REGISTERED_WELCOME_FAN'
    }); // console.log('template', template)

    var body = template.value.body.replace('$USERNAME', userToCreate.profile.name);
    var data = {
      // Use the 'data' key for the message body
      'attributes': {
        'USERNAME': userToCreate.profile.name,
        'REGISTERED': true,
        'FINISHED_REGISTER': false,
        'FINISHED_FUNDING': false,
        'ORIGIN': userToCreate.profile.tags ? userToCreate.profile.tags[0] : null,
        'EXT_ID': userToCreate._id,
        'LOCALE': userToCreate.profile.locale
      },
      'email': userToCreate.profile.email,
      updateEnabled: true
    };
    console.log('data', data);
    runHook('brevo.syncContact', data); // the Brevo list, server only (core/server/brevo.js, #525)
    //greenmapper@mail4qa.com

    sendHtmlEmail('greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body);
    return userToCreate;
  }); // Accounts.onUpdateUser((options, user) => {
  //     // console.log('----------------------Accounts.onCreateUser --------------------------------')
  //     const userToCreate = Object.assign({
  //         createdAt: new Date()
  //     }, user)
  //
  //     if (options.profile) userToCreate.profile = options.profile
  //
  //     return userToCreate
  // })
  // Router.route('/content/:file', { where: 'server' }).get(function () {
  //     console.log('params.file', this.params.file)
  //     let contentFile = content[this.params.file]
  //     console.log('contentFile EXISTS: ', contentFile !== undefined)
  //     // var response = Images.find({
  //     //     userid: this.params.userid
  //     // }).fetch();
  //     // //
  //     this.response.setHeader('Content-Type', 'application/json')
  //     // this.response.end(introductie)
  //     this.response.end(JSON.stringify(contentFile))
  // })
  // SSL( Assets.getText('C:\\playground\\mybetaquasar\\api\\localhost.key'), Assets.getText('C:\\playground\\mybetaquasar\\api\\localhost.cert'), 443)

  /*  SSL(
      'assets/app/localhost.key',
      'assets/app/localhost.cert',
      443)
   SSL(
      'assets/app/localhost.key',
      'assets/app/localhost.cert',
      4000)
  */
  // Listen to incoming HTTP requests (can only be used on the server).
  // WebApp.connectHandlers.use('*', (req, res, next) => {
  //     res.writeHead(205)
  //     res.setHeader('X-Clacks-Overhead', 'GNU Terry Pratchett')
  //     res.end(`Hello world from: ${Meteor.release}`)
  // })

  /*  Meteor.startup(function () {
      console.log('----------settting request headers--------------')
      WebApp.rawConnectHandlers.use(function (req, res, next) {
          res.setHeader('X-Clacks-Overhead', 'GNU Terry Pratchett')
          res.setHeader('Access-Control-Allow-Origin', '*')
          res.setHeader('Access-Control-Allow-Methods', 'POST')
          res.writeHead(200)
          res.end()
      })
      WebApp.connectHandlers.use(function (req, res, next) {
          // add allow origin
          res.setHeader('Access-Control-Allow-Origin', '*')
          res.setHeader('X-Clacks-Overhead', 'GNU Terry Pratchett')
           res.setHeader('Access-Control-Allow-Headers', [
              'Accept',
              'Accept-Charset',
              'Accept-Encoding',
              'Accept-Language',
              'Accept-Datetime',
              'Authorization',
              'Cache-Control',
              'Connection',
              'Cookie',
              'Content-Length',
              'Content-MD5',
              'Content-Type',
              'Date',
              'User-Agent',
              'X-Requested-With',
              'Origin'
          ].join(', '))
      })
  })  */
  // Meteor.publish('directory', function () {
  //     var currentUser
  //     currentUser = this.userId
  //     // return Meteor.users.find({}, { fields: { emails: 1, profile: 1 } })
  //     return Meteor.users.find({ _id: currentUser }, { fields: { emails: 1, profile: 1 } })
  // })

  Meteor.publish('tasks', function tasksPublication() {
    return Tasks.find();
  });
  Meteor.publish('measures', function measuresPublication() {
    this.unblock();
    return Measures.find({}, {
      sort: {
        dateCreated: -1
      },
      fields: {// 'id': 1,
        // 'type': 1,
        // 'geometry': 1,
      } // limit:

    });
  });
  Meteor.publish('land', function landPublication() {
    this.unblock(); // a community waiting for its first approval (#96) is only seen by its owner and admins (the test server's demo
    // admin: the demo ones, #472, demo/server/access.js)

    var user = this.userId ? Meteor.users.findOne({
      _id: this.userId
    }, {
      fields: {
        profile: 1,
        emails: 1,
        demo: 1
      }
    }) : null;
    var query = isAdmin(user) ? {} : {
      $or: [{
        fansAfterApproval: {
          $ne: true
        }
      }, {
        createdBy: this.userId || '-'
      }].concat(runHook('demoLandsFor', user) || [])
    };
    return Land.find(query, {
      sort: {
        dateCreated: -1
      },
      fields: {
        // 'id': 1,
        // 'type': 1,
        // 'geometry': 1,
        // community review: the rejection reason goes to the admin and the owner by method only (owners/, D65)
        'reviewFeedback': 0,
        // the fan zone's shape goes to the admin's review by method only (fanZone/, #96); its size and position are public
        'fanZone.geometry': 0,
        // the shape last approved, kept while a change waits for the admin (fanZone/, #96)
        'approvedMatch': 0
      } // limit:

    });
  });
  Meteor.publish('KV', function KVPublication() {
    return KV.find({
      key: {
        $nin: UNPUBLISHED_KV_KEYS
      }
    }, {});
  });
  /*Meteor.publish('aeraFriends', function measuresPublication () {
      this.unblock();
      return Measures.find({}, {
          sort: {dateCreated: -1},
          fields: {
              // 'id': 1,
              // 'type': 1,
              // 'geometry': 1,
          },
          // limit:
      })
  })*/
  // Meteor.publish('measures', function measuresPublication () {
  //     return Measures.find()
  // })

  Meteor.publish('notices', function noticesPublication() {
    return Notices.find();
  });
  /*Meteor.publish('gebied', function gebiedPublication () {
      return Gebied.find()
  })*/

  Meteor.publish('adverts', function advertsPublication() {
    return Adverts.find();
  });
  Meteor.startup(function () {
    Measures._ensureIndex({
      dateCreated: -1
    });
  }); // 'thisNameDoesNotMatter' (what the browser gets of the users): core/server/userData.js (#520)
  // Meteor.publish('userdata', function measuresPublication () {
  //     return Meteor.users.find()
  // })
  // Meteor.publish('userdata2', function () {
  //     var currentUser
  //     currentUser = Meteor.userId()
  //     if (currentUser) {
  //         return Meteor.users.find({
  //             _id: currentUser
  //         }, {
  //             fields: {
  //                 'emails': 1
  //             }
  //         })
  //     } else {
  //         return this.ready()
  //     }
  // })
}

Meteor.methods({
  // logs (the fans' activity log) moved to core/server/logs.js with its permission check; _logs removed (#575)
  _intersectAreas: function _intersectAreas(coords) {
    console.log(coords);
    var intersectLands = Measures.find({
      geometry: {
        $geoIntersects: {
          $geometry: {
            type: 'Polygon',
            coordinates: [[[6.313796, 53.429174], [6.314392, 53.31939], [6.127625, 53.311186], [6.141357, 53.429174], [6.313796, 53.429174]]] //coordinates: coords
            // [ [ 1.313796, 1.429174 ], [ 1.314392, 1.31939 ], [ 1.127625, 1.311186 ], [ 1.141357, 1.429174 ], [ 1.313796, 1.429174 ] ]

          }
        }
      }
    }).fetch(); // let intersectLands = result.

    /*intersectLands.forEach((land) => {
        console.log("A")
        console.log(land.id)
    })*/
    // console.log('\x1b[32m%s\x1b[0m', 'TEST method called')

    console.log('\x1b[32m%s\x1b[0m', intersectLands);
    return {
      status: 200,
      //message: 'this is a server response :)'
      message: intersectLands
    };
  },
  'tasks.insert': function tasksInsert(title) {
    check(title, String);
    Tasks.insert({
      title: title,
      createdAt: new Date()
    });
  },
  'tasks.update': function tasksUpdate(taskId, task) {
    check(taskId, String);
    check(task, String);
    Tasks.update(taskId, {
      $set: {
        _id: taskId,
        updatedAt: new Date(),
        title: task
      }
    });
  },
  'tasks.remove': function tasksRemove(taskId) {
    check(taskId, String);
    Tasks.remove(taskId);
  },
  // 'land.insert' removed (24 Sep 2026, D73): no permission checks; communities are created by owner.community.create(Official) in api/imports/api/owners/
  'measure.insert': function measureInsert(measure, data, analitics) {
    /* console.log('\x1b[32m%s\x1b[0m', 'CREATED Marker [id:'+id+', userid:'+measure.properties.userid+']'); */
    console.log('\x1b[32m%s\x1b[0m', 'CALL: measure.insert START'); // console.log('measure', measure)
    // console.log('data', data)
    // console.log('user', Meteor.userId() + Meteor.user().emails)
    // console.log('email', Meteor.user().emails)

    delete measure['properties'];

    var area = _objectSpread({}, measure, {}, data, {}, analitics); // the drawing tools never send a shape MongoDB cannot match; this is the safeguard behind them (#205, #7). A
    // position repeated by a double click (the old PBL survey's tool, removed in #509) is dropped first: the same shape


    area.geometry = withoutRepeatedPositions(area.geometry);
    var shapeProblem = geometryRejectReason(area.geometry, SHAPE_LIMITS.fanArea) || mongoRejectReason(Measures, area.geometry);
    if (shapeProblem) throw new Meteor.Error('invalid-shape', 'This shape cannot be saved (' + shapeProblem + ')');
    if (!validLevel(area.level)) throw new Meteor.Error('invalid-level', 'The level must be 2, 3, 4 or 5, or none'); // console.log('measure', area)
    // console.log('measure', area.geometry.coordinates)

    area.dateCreated = data.dateCreated ? data.dateCreated : new Date();
    area.createdBy = data.createdBy ? data.createdBy : Meteor.userId();
    /*// UUID
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'
     var uuid = s.join('')*/

    area.id = genUuid();

    var _id = Measures.insert(area); // the rest is the server's: the registration's end, Brevo, the score and the matching communities. The browser's
    // simulation sees only part of the data (and no settings), so it stops here (#221)


    if (Meteor.isClient) return;

    if (Meteor.user().profile.finishedRegister !== true) {
      var measures = Measures.find({
        'createdBy': Meteor.userId()
      }, {
        sort: {
          dateCreated: -1
        }
      }).fetch();

      if (measures && measures.length === 4) {
        Meteor.users.update({
          _id: Meteor.userId()
        }, {
          // $push: { 'profile.subs': intersectLand.id }
          $set: {
            'profile.finishedRegister': true
          }
        });
        var _data = {
          'attributes': {
            'FINISHED_REGISTER': true
          },
          'email': Meteor.user().profile.email,
          updateEnabled: true
        }; // console.log('data2',data)

        runHook('brevo.syncContact', _data); // the Brevo list, server only (core/server/brevo.js, #525)
      }
    } //Update score


    var amountInc = KV.findOne({
      'key': 'DRAW_AREA'
    }).value;
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $inc: {
        'profile.score': amountInc
      }
    }); // area.analitics = analitics
    // Meteor._sleepForMs(3000)
    // INTERSECT for subs

    /*let intersectLands = Land.find(
        {
            geometry: {
                $geoIntersects: {
                    $geometry: {
                        type: 'Polygon',
                        coordinates: area.geometry.coordinates
                        // [ [ 1.313796, 1.429174 ], [ 1.314392, 1.31939 ], [ 1.127625, 1.311186 ], [ 1.141357, 1.429174 ], [ 1.313796, 1.429174 ] ]
                        //[ [ 6.313796, 53.429174 ], [ 6.314392, 53.31939 ], [ 6.127625, 53.311186 ], [ 6.141357, 53.429174 ], [ 6.313796, 53.429174 ] ]
                     }
                }
            }
        }
    )*/

    try {
      // server: fanZone/server/matching.js (every community on its fan zone, else its boundary, #96)
      var intersectLands = runHook('landsForArea', area.geometry) || Land.find({
        geometry: {
          $geoIntersects: {
            $geometry: area.geometry
          }
        }
      });
      intersectLands.forEach(function (land) {
        if (!land.system) {
          Meteor.users.update({
            _id: Meteor.userId()
          }, {
            // once per community, also when the fan draws another area in it (#15: it was $push)
            $addToSet: {
              'profile.subs': land.id
            },
            $inc: {
              'profile.score': 5
            }
          });
        }
      });
    } catch (e) {
      console.log(e);
    }

    console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
    console.log('\x1b[32m%s\x1b[0m', 'CREATED Measure ' + _id);
    console.log('\x1b[32m%s\x1b[0m', 'CALL: measure.insert END');
  },
  'measure.delete': function measureDelete(measureId) {
    console.log('CALL: measure.delete START', measureId);
    var measure = Measures.findOne({
      '_id': measureId
    });

    if (measure.createdBy === Meteor.userId()) {
      Measures.remove(measureId);
      /*Meteor.users.update({ _id: Meteor.userId() }, {
          $inc: { 'profile.score': -1 }
      })*/
    } else {
      throw new Meteor.Error('not allowed', 'Cannot delete measure');
    }

    console.log('measure.delete END', measureId);
  },
  'measure.update': function measureUpdate(measureId, data) {
    console.log('CALL: measure.update START', measureId); // console.log('measureId', measureId)

    console.log('data', data);
    console.log('data...', data); // console.log('user', Meteor.userId() + Meteor.user().emails)
    // console.log('email', Meteor.user().emails)

    var measure = Measures.findOne({
      '_id': measureId
    }); // console.log('measure', measure)
    // check(title, String)
    // check(description, String)
    // the geometry only as a whole (a dotted key like 'geometry.coordinates' would pass by the check)

    if (data && Object.keys(data).some(function (k) {
      return k !== 'geometry' && k.indexOf('geometry.') === 0;
    })) throw new Meteor.Error('invalid-shape', 'Send the geometry as a whole');

    if (data && data.geometry !== undefined) {
      var shapeProblem = geometryRejectReason(data.geometry, SHAPE_LIMITS.fanArea) || mongoRejectReason(Measures, data.geometry);
      if (shapeProblem) throw new Meteor.Error('invalid-shape', 'This shape cannot be saved (' + shapeProblem + ')');
    }

    if (data && !validLevel(data.level)) throw new Meteor.Error('invalid-level', 'The level must be 2, 3, 4 or 5, or none');

    if (measure.createdBy === Meteor.userId()) {
      console.log('-----------ok---------------');
      var result = Measures.update(measureId, {
        $set: _objectSpread({
          updatedAt: new Date()
        }, data)
      });
      console.log('-----------result-----------', result);
    }

    measure = Measures.findOne({
      '_id': measureId
    });
    console.log('measure UPDATED', measure);
    console.log('measure.update END', measureId);
  },
  // 'editCommunity' removed (24 Sep 2026, D73): no permission checks; communities are edited by community.update in api/imports/api/owners/
  // 'deleteCommunity' removed (#15, 14 Oct 2026): no permission checks, and it left the community in its fans'
  // subscriptions; communities are deleted by admin.community.delete (owners/server/cascade.js)
  'register.saveFunding': function registerSaveFunding(data) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.amount': Number(data.amount),
        'profile.reason': data.reason
      }
    });
  },
  'register.pauze': function registerPauze() {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.register_pauzed': true
      }
    });
  },
  'addFunding': function addFunding(obj) {
    obj.createdAt = new Date();
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $push: {
        'profile.funding': obj
      }
    });
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        'profile.amount': Number(obj.amount),
        'profile.reason': obj.reason
      }
    }); //Update score

    var amountInc = KV.findOne({
      'key': 'ADD_VIRTUAL_FUNDING'
    }).value;
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $inc: {
        'profile.score': amountInc
      }
    });

    if (Meteor.user().profile.finishedFunding !== true) {
      Meteor.users.update({
        _id: Meteor.userId()
      }, {
        // $push: { 'profile.subs': intersectLand.id }
        $set: {
          'profile.finishedFunding': true
        }
      });
      var data = {
        'attributes': {
          'FINISHED_FUNDING': true
        },
        'email': Meteor.user().profile.email,
        updateEnabled: true
      }; // console.log('data2',data)

      runHook('brevo.syncContact', data); // the Brevo list, server only (core/server/brevo.js, #525)
    }
  },
  'unsubscribe': function unsubscribe(landId) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $pull: {
        'profile.subs': landId
      }
    });
  },
  'subscribe': function subscribe(landId) {
    // a community waiting for its first approval cannot be joined (#96): only its owner and admins see it
    if (Meteor.isServer) {
      check(landId, String);
      var land = Land.findOne({
        id: landId
      }, {
        fields: {
          fansAfterApproval: 1,
          createdBy: 1
        }
      });

      if (!land || land.fansAfterApproval && land.createdBy !== Meteor.userId() && !isAdmin(Meteor.user())) {
        throw new Meteor.Error('not-found', 'Community not found');
      }
    }

    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $addToSet: {
        'profile.subs': landId
      }
    });
  },
  // asking to moderate: a member asks for themselves (#18)
  'addModeratorRequest': function addModeratorRequest(communityId) {
    check(communityId, String);
    var user = requireCommunityRole('member', Land.findOne({
      id: communityId
    }));
    Land.update({
      id: communityId
    }, {
      $addToSet: {
        'modrequests': user._id
      }
    });
  },
  // a request denied by the owner, a moderator or an admin, or taken back by the one who asked (#18)
  'removeModeratorRequest': function removeModeratorRequest(userId, communityId) {
    check([userId, communityId], [String]);
    requireCommunityRole('manager', Land.findOne({
      id: communityId
    }), userId);
    Land.update({
      id: communityId
    }, {
      $pull: {
        'modrequests': userId
      }
    });
  },
  // a request accepted by the owner, a moderator or an admin: only someone who asked (#18; anyone could make
  // themselves moderator, which passed every manager check)
  'addModerator': function addModerator(userId, communityId) {
    check([userId, communityId], [String]);
    var land = Land.findOne({
      id: communityId
    });
    requireCommunityRole('manager', land);
    if ((land.modrequests || []).indexOf(userId) === -1) throw new Meteor.Error('not-found', 'No such moderator request');
    Land.update({
      id: communityId
    }, {
      $pull: {
        'modrequests': userId
      },
      $addToSet: {
        'mods': userId
      }
    });
  },
  'addThread': function addThread(communityId, title, description, base64Images) {
    check([communityId, title, description], [String]);
    check(base64Images, [String]);
    requireCommunityRole('member', Land.findOne({
      id: communityId
    })); // members only (community/access.js, #18)

    runHook('uploads.check', base64Images); // server only: a login, JPEGs, at most MAX_IMAGES (core/server/uploads.js, #522)

    console.log('base64Images', base64Images); // console.log("base64Image")
    // //console.log(base64Image)
    // // UUID
    // var s = []
    // var hexDigits = '0123456789abcdef'
    // for (var i = 0; i < 36; i++) {
    //     s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    // }
    // s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    // s[8] = s[13] = s[18] = s[23] = '-'
    //
    // var uuid = s.join('')

    var threadUUID = genUuid();
    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      runHook('uploads.image', base64Image, threadUUID, uuid); // server only (core/server/uploads.js, #522)
    }); //console.log('base64Images',base64Images)
    // const imageName = Meteor.call('uploadImageFileBase64', base64Image, '112233')

    Land.update({
      id: communityId
    }, {
      $push: {
        'threads': {
          id: threadUUID,
          title: title,
          description: cleanHtml(description),
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          comments: [],
          images: imageUuids
        }
      }
    });
  },
  'editThread': function editThread(id, communityId, title, description, base64Images) {
    check([id, title, description], [String]);
    check(base64Images, [String]); // its community's owner or moderators, or its author (community/access.js, #18); the post's id is also the
    // pictures' folder on the CDN: only an existing post's (#522)

    var _findThread2 = findThread(id),
        land = _findThread2.land,
        thread = _findThread2.thread;

    requireCommunityRole('manager', land, thread.createdBy);
    runHook('uploads.check', base64Images); // server only: a login, JPEGs, at most MAX_IMAGES (core/server/uploads.js, #522)
    // //console.log(base64Image)
    // // UUID
    // var s = []
    // var hexDigits = '0123456789abcdef'
    // for (var i = 0; i < 36; i++) {
    //     s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    // }
    // s[14] = '4'  // bits 12-15 of the time_hi_and_version field to 0010
    // s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    // s[8] = s[13] = s[18] = s[23] = '-'
    //
    // var uuid = s.join('')
    //let threadUUID =  genUuid()

    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      runHook('uploads.image', base64Image, id, uuid); // server only (core/server/uploads.js, #522)
    }); //console.log('base64Images',base64Images)
    // const imageName = Meteor.call('uploadImageFileBase64', base64Image, '112233')

    Land.update({
      'threads.id': id // id: communityId

    }, {
      $set: {
        'threads.$.title': title,
        'threads.$.description': cleanHtml(description),
        'threads.$.images': imageUuids,
        'threads.$.updatedAt': new Date()
      } // $push: {
      //     'threads': {
      //         id: threadUUID,
      //         title: title,
      //         description: description,
      //         createdBy: Meteor.userId(),
      //         createdByName: Meteor.user().profile.name,
      //         createdAt: new Date(),
      //         comments: [],
      //         images: imageUuids
      //     }
      // }

    });
  },
  'deleteThread': function deleteThread(threadId) {
    check(threadId, String);

    var _findThread3 = findThread(threadId),
        land = _findThread3.land,
        thread = _findThread3.thread;

    requireCommunityRole('manager', land, thread.createdBy); // owner, moderators or its author (community/access.js, #18)
    // only this post: writing the whole list back lost what others added meanwhile

    Land.update({
      id: land.id
    }, {
      $pull: {
        threads: {
          id: threadId
        }
      }
    });
  },
  'addMeeting': function addMeeting(communityId, title, description, url, startTime) {
    check(communityId, String);
    check(title, meetingTitle);
    check(startTime, shortText);
    check(description, longText);
    check(url, linkText);
    requireCommunityRole('manager', Land.findOne({
      id: communityId
    })); // the owner or moderators (community/access.js, #18)

    description = cleanHtml(description); // UUID

    var s = [];
    var hexDigits = '0123456789abcdef';

    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }

    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    Land.update({
      id: communityId
    }, {
      $push: {
        'meetings': {
          id: uuid,
          title: title,
          description: description,
          link: /^https?:\/\//.test(url) ? url : 'https://' + url,
          startTime: startTime,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          linkSent: false,
          accepted: [],
          rejected: []
        }
      }
    });
    var community = Land.findOne({
      'id': communityId
    }); //console.log("community",community)

    var users = Meteor.users.find(); //console.log('users', users)

    var newUrl = publicSettings().serverUrl + '/meeting/' + uuid;
    users.forEach(function (user) {
      if ((user.profile && user.profile.subs || []).includes(community.id)) {
        //console.log('send invite to: ' + user.profile.email)
        var template = KV.findOne({
          'key': 'MEETING_INVITED'
        });
        var body = template.value.body; //  console.log("BODY",body)

        body = template.value.body.replace('$USERNAME', escapeText(user.profile.name));
        body = replaceAll(body, '$URL', escapeText(newUrl));
        body = replaceAll(body, '$COMMUNITY_NAME', escapeText(community.title));
        /*                var str = 'Hi Friends user ' + user.profile.name + '\n\n'
                        str += 'You have been invited to an online meeting by the ' + community.title + ' community' + '\n\n'
                        str += 'The details about this meeting can be found below. Please note that in some cases the number of people wanting to join can be too big. In that case we will make a random selection from the people that shows interest in the meeting. For that reason we ask you to either Accept or Decline the invitation.' + '\n\n'
                        str += newUrl*/

        sendHtmlEmail( //user.profile.email,
        'greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body); // }
      }
    });
  },
  'deleteMeeting': function deleteMeeting(meetingId) {
    var _findItem2 = findItem('meetings', meetingId),
        land = _findItem2.land; // the owner or moderators; not its author: one who is no moderator any more keeps no rights (community/access.js, #18)


    requireCommunityRole('manager', land); // only this meeting: writing the whole list back lost what others wrote meanwhile

    Land.update({
      id: land.id
    }, {
      $pull: {
        meetings: {
          id: meetingId
        }
      }
    });
  },

  /*    'sendFundingInvites' (communityId) {
          let land = Land.findOne({ 'id': communityId })
           let users = Meteor.users.find({}).fetch()
           users.forEach(user => {
              if (!user.profile.funding && user.profile.subs.includes(communityId)) {
                   const newUrl = publicSettings().serverUrl + '/survey/funding'
                   var str = 'Hi user ' + user.profile.name + '\n\n'
                  str += 'You have been selected to join the online funding survey' + '\n\n'
                  str += 'Go to link to take part in the survey:' + '\n\n'
                  str += newUrl + '\n\n'
                   Meteor.call(
                      'sendEmail',
                      user.profile.email,
                      //'greenmapper@mail4qa.com',
                      'friends@greenmapper.org',
                      'Greenmapper: Link for funding survey',
                      str
                  )
               }
          })
       },*/
  'sendInvites': function sendInvites(communityId, meetingId, link, startTime, number) {
    console.log('CALLED: sendInvites');
    check(communityId, String);
    check(link, linkText); // the form sends back the meeting's own (older meetings may hold a date)

    check(startTime, Match.OneOf(shortText, Date)); // how many of those who accepted get the link (the form's number field)

    check(number, Match.OneOf(Match.Integer, String));
    number = Number(number);
    if (!Number.isInteger(number) || number < 1 || number > 100000) throw new Meteor.Error('bad-number', 'How many: 1 to 100000');

    var _findItem3 = findItem('meetings', meetingId),
        land = _findItem3.land,
        meeting = _findItem3.item;

    if (land.id !== communityId) throw new Meteor.Error('not-found', 'No such meeting in this community'); // the owner or moderators; not its author: one who is no moderator any more keeps no rights (community/access.js, #18)

    requireCommunityRole('manager', land);
    meeting.startTime = startTime; // the link with its https:// as addMeeting keeps it (the form sends it without; #340)

    meeting.link = /^https?:\/\//.test(link) ? link : 'https://' + link;
    var users = Meteor.users.find({
      '_id': {
        '$in': meeting.accepted
      }
    }).fetch();
    users.shuffle();
    var users2 = users.slice(0, number);
    users2.forEach(function (user) {
      // console.log(user.profile.email)
      var template = KV.findOne({
        'key': 'MEETING_SELECTED'
      });
      var body = template.value.body;
      body = template.value.body.replace('$USERNAME', escapeText(user.profile.name));
      body = replaceAll(body, '$URL', escapeText(meeting.link));
      body = replaceAll(body, '$COMMUNITY_NAME', escapeText(land.title));
      body = replaceAll(body, '$START_TIME', escapeText(startTime));
      body = replaceAll(body, '$MEETING_TITLE', escapeText(meeting.title));
      body = replaceAll(body, '$MEETING_DESCRIPTION', meeting.description); // params: ['$USERNAME','$URL','$COMMUNITY_NAME','$START_TIME','$MEETING_TITLE','$COMMUNITY_NAME']

      /*            var str = 'Hi user ' + user.profile.name + '\n\n'
                  str += 'You have been selected to join the online meeting! We want to thank you for showing interest and look forward to meeting with you.' + '\n\n'
                  str += 'Go to link to join the meeting:' + meeting.link + '\n\n'
                  str += meeting.link + '\n\n'
                  str += 'Time of meeting: ' + meeting.startTime + '\n\n'
                  str += 'Title of meeting: ' + meeting.title + '\n\n'
                  str += 'Description of meeting: ' + meeting.description + '\n\n'
                  str += 'Name of community: ' + land.title + '\n\n'*/

      sendHtmlEmail( //user.profile.email,
      'greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body);
    }); // only this meeting's fields: writing the whole list back lost what others wrote meanwhile

    Land.update({
      id: land.id,
      'meetings.id': meetingId
    }, {
      $set: {
        'meetings.$.linkSent': true,
        'meetings.$.startTime': startTime,
        'meetings.$.number': number,
        'meetings.$.link': meeting.link
      }
    });
  },
  'acceptInvite': function acceptInvite(meetingId) {
    answerInvite(meetingId, 'accepted', 'rejected');
  },
  'rejectInvite': function rejectInvite(meetingId) {
    answerInvite(meetingId, 'rejected', 'accepted');
  },
  'isRead': function isRead(messageId) {
    var _findItem4 = findItem('messages', messageId),
        land = _findItem4.land,
        message = _findItem4.item; // only its recipients mark it read; for anyone else (its sender, from the outbox) nothing changes (#18)


    if ((message.cc || []).indexOf(Meteor.userId()) === -1) return;
    Land.update({
      id: land.id,
      'messages.id': messageId
    }, {
      $addToSet: {
        'messages.$.rcc': Meteor.userId()
      }
    });
  },
  'addMessage': function addMessage(communityId, data) {
    check(communityId, String);
    check(data, Match.ObjectIncluding({
      title: messageTitle,
      body: longText
    }));
    var community = Land.findOne({
      'id': communityId
    });
    requireCommunityRole('manager', community); // the owner or moderators write as the community (community/access.js, #18)

    var uuid = genUuid();
    var cc = [];
    var users = [];
    Meteor.users.find({}).forEach(function (user) {
      if (community.system || !user.profile.owner && user.profile.subs && user.profile.subs.includes(communityId)) {
        cc.push(user._id);
        users.push(user);
      }
    });
    Land.update({
      id: communityId
    }, {
      $push: {
        'messages': {
          id: uuid,
          title: data.title,
          body: cleanHtml(data.body),
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          from: community.title,
          fromId: community.id,
          cc: cc,
          rcc: [],
          system: community.system
        }
      }
    });
    var count = 0;
    users.forEach(function (user) {
      // console.log(user.profile.email)
      // Client: Asynchronously send an email.
      // if (user.profile.email === 'dobbel01@hotmail.com') {
      var link = publicSettings().serverUrl + '/inbox'; //let link = 'https://friends.greenmapper.org/inbox'

      var template = KV.findOne({
        'key': 'COMMUNITY_MESSAGE'
      });
      var body = template.value.body;
      body = template.value.body.replace('$USERNAME', escapeText(user.profile.name));
      body = replaceAll(body, '$URL', escapeText(link));
      body = replaceAll(body, '$COMMUNITY_NAME', escapeText(community.title));
      body = replaceAll(body, '$MESSAGE_TITLE', escapeText(data.title));
      /*var str = 'Hi user ' + user.profile.name + ',\n\n'
      str += 'There is a new message from the \'' + community.title + '\' community' + '\n\n'
      // str += 'from: ' + community.title+ '\n\n'
      // str +=  community.title+ ':\n'
      str += '"' + data.title + '"' + '\n\n'
      str += 'Go to this link to see the message:' + '\n\n'
      str += link + '\n\n'
      str += 'Greetings from the Greenmapper Friends team' + '\n\n'*/
      // str +=  link
      //greenmapper@mail4qa.com

      if (count === 0) {
        sendHtmlEmail('greenmapper@mail4qa.com', 'friends@greenmapper.org', template.value.title, body);
        count++;
      }
    });
  },
  'mailer': function mailer(data) {
    // the admin's mailer screen only (#249)
    if (!isAdmin(Meteor.user())) throw new Meteor.Error('not-authorized', 'Admin only');
    console.log('CALLED: Mailer');
    check(data, Match.ObjectIncluding({
      title: String,
      body: String
    }));

    if (data.testEmail) {
      var body = data.body.replace('$USERNAME', 'John Doe');
      sendHtmlEmail(data.testEmail, 'friends@greenmapper.org', data.title, body);
    } else {
      var users = [];
      (Array.isArray(data.userIds) ? data.userIds : []).forEach(function (id) {
        // an account deleted meanwhile is left out
        var aUser = Meteor.users.findOne({
          '_id': id
        });
        if (aUser) users.push(aUser);
      });
      var count = 0;
      users.forEach(function (user) {
        var body = data.body.replace('$USERNAME', user.profile && user.profile.name || ''); //greenmapper@mail4qa.com

        if (count === 0) {
          sendHtmlEmail('greenmapper@mail4qa.com', 'friends@greenmapper.org', data.title, body);
          count++;
        }
      });
    }
  },
  'addPolis': function addPolis(communityId, title, polisId, options) {
    check(communityId, String);
    check(title, filledText(200));
    check(polisId, String); // pol.is's conversation id (letters and digits), also from a pasted link (https://pol.is/<id>)

    polisId = polisId.trim().replace(/^https?:\/\/(www\.)?pol\.is\//, '').replace(/[/?#].*$/, '');
    if (!/^[A-Za-z0-9_-]{1,100}$/.test(polisId)) throw new Meteor.Error('bad-polis-id', 'A Polis id is letters and digits, as in pol.is/<id>');
    check(options, Match.ObjectIncluding({
      ucw: Match.Optional(Boolean),
      ucv: Match.Optional(Boolean)
    }));
    requireCommunityRole('manager', Land.findOne({
      id: communityId
    })); // the owner or moderators (community/access.js, #18)

    Land.update({
      id: communityId
    }, {
      $push: {
        'polis': {
          id: genUuid(),
          title: title,
          polisId: polisId,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          // only the two switches pol.is's embed reads (PolisPage.vue)
          options: {
            ucw: options.ucw !== false,
            ucv: options.ucv !== false
          }
        }
      }
    });
  },
  'deletePolis': function deletePolis(pollId) {
    var _findItem5 = findItem('polis', pollId),
        land = _findItem5.land;

    requireCommunityRole('manager', land); // the owner or moderators (community/access.js, #18)
    // only this one: writing the whole list back lost what others wrote meanwhile

    Land.update({
      id: land.id
    }, {
      $pull: {
        polis: {
          id: pollId
        }
      }
    });
  },
  'addPoll': function addPoll(communityId, title, description, polisId, options) {
    check(communityId, String);
    check(title, filledText(200));
    check(description, Match.Maybe(longText)); // not used (the wizard sends none)

    check(polisId, Match.Any);
    check(options, [Match.ObjectIncluding({
      text: filledText(POLL_OPTION_MAX_LENGTH)
    })]);
    if (options.length < 2 || options.length > POLL_OPTIONS_MAX) throw new Meteor.Error('bad-options', 'A poll has 2 to ' + POLL_OPTIONS_MAX + ' answers');
    requireCommunityRole('manager', Land.findOne({
      id: communityId
    })); // the owner or moderators (community/access.js, #18)

    Land.update({
      id: communityId
    }, {
      $push: {
        'polls': {
          id: genUuid(),
          title: title,
          description: cleanHtml(description),
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          // the answers numbered here, without votes: the wizard's numbers repeat after a removed answer
          options: options.map(function (option, index) {
            return {
              text: option.text,
              value: index + 1,
              votes: []
            };
          })
        }
      }
    });
  },
  'deletePoll': function deletePoll(pollId) {
    var _findItem6 = findItem('polls', pollId),
        land = _findItem6.land;

    requireCommunityRole('manager', land); // the owner or moderators (community/access.js, #18)
    // only this one: writing the whole list back lost what others wrote meanwhile

    Land.update({
      id: land.id
    }, {
      $pull: {
        polls: {
          id: pollId
        }
      }
    });
  },
  // 'addPledge' (communityId, title, description, goal) {
  'addPledge': function addPledge(communityId, data, base64Images) {
    check(communityId, String);
    check(data, PLEDGE_DATA);
    check(base64Images, [String]);
    requireCommunityRole('manager', Land.findOne({
      id: communityId
    })); // the owner or moderators (community/access.js, #18)

    runHook('uploads.check', base64Images); // server only: a login, JPEGs, at most MAX_IMAGES (core/server/uploads.js, #522)

    var pledgeUUID = genUuid();
    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      runHook('uploads.image', base64Image, pledgeUUID, uuid); // server only (core/server/uploads.js, #522)
    });
    Land.update({
      id: communityId
    }, {
      $push: {
        'pledges': {
          id: pledgeUUID,
          title: data.title,
          description: cleanHtml(data.description),
          goal: Number(data.goal),
          amount: 0,
          number: 0,
          reasons: [],
          type: data.type,
          geometry: data.geometry,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          images: imageUuids,
          data: []
        }
      }
    });
  },
  'editPledge': function editPledge(id, communityId, data, base64Images) {
    // (communityId: the browser's, unused; the pledge's own community counts)
    check(data, PLEDGE_DATA);
    check(base64Images, [String]); // the owner, moderators or its author (community/access.js, #18); the pledge's id is also the pictures' folder
    // on the CDN: only an existing pledge's (#522)

    var _findItem7 = findItem('pledges', id),
        land = _findItem7.land,
        item = _findItem7.item;

    requireCommunityRole('manager', land, item.createdBy);
    runHook('uploads.check', base64Images); // server only: a login, JPEGs, at most MAX_IMAGES (core/server/uploads.js, #522)
    //let pledgeUUID =  genUuid()

    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      runHook('uploads.image', base64Image, id, uuid); // server only (core/server/uploads.js, #522)
    });
    Land.update({
      'pledges.id': id
    }, {
      '$set': {
        'pledges.$.title': data.title,
        'pledges.$.description': cleanHtml(data.description),
        'pledges.$.images': imageUuids,
        'pledges.$.updatedAt': new Date(),
        'pledges.$.goal': Number(data.goal),
        'pledges.$.type': data.type,
        'pledges.$.geometry': data.geometry
      }
    });
  },
  'deletePledge': function deletePledge(pledgeId) {
    var _findItem8 = findItem('pledges', pledgeId),
        land = _findItem8.land,
        item = _findItem8.item;

    requireCommunityRole('manager', land, item.createdBy); // the owner, moderators or its author (community/access.js, #18)
    // only this pledge: writing the whole list back lost what others added meanwhile

    Land.update({
      id: land.id
    }, {
      $pull: {
        pledges: {
          id: pledgeId
        }
      }
    });
  },
  'addTreasure': function addTreasure(communityId, data, base64Images) {
    check(communityId, String);
    check(data, ITEM_DATA);
    check(base64Images, [String]);
    requireCommunityRole('member', Land.findOne({
      id: communityId
    })); // members only (community/access.js, #18)

    runHook('uploads.check', base64Images); // server only: a login, JPEGs, at most MAX_IMAGES (core/server/uploads.js, #522)

    var aUUID = genUuid();
    var imageUuids = [];
    base64Images.forEach(function (base64Image) {
      var uuid = genUuid();
      imageUuids.push(uuid);
      runHook('uploads.image', base64Image, aUUID, uuid); // server only (core/server/uploads.js, #522)
    });
    Land.update({
      id: communityId
    }, {
      $push: {
        'treasures': {
          id: aUUID,
          title: data.title,
          description: cleanHtml(data.description),
          geometry: data.geometry,
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          image: imageUuids[0],
          flagged: false,
          report_text: ''
        }
      }
    });
  },
  // a report: anyone logged in, as the treasure's menu offers (#18); the text is added to the earlier ones, as long as
  // they stay under REPORT_TEXT_MAX (a report always flags the treasure)
  'reportTreasure': function reportTreasure(treasureId, text) {
    requireLogin();
    check(text, String);

    for (var attempt = 0; attempt < 3; attempt++) {
      var _findItem9 = findItem('treasures', treasureId),
          item = _findItem9.item;

      var before = item.report_text || '';
      var after = before.length > REPORT_TEXT_MAX ? before : before + '\n' + '-----------------------------' + '\n' + text.slice(0, 2000); // only while nobody else reported meanwhile (else their report would be lost): read again

      var changed = Land.update({
        treasures: {
          $elemMatch: {
            id: treasureId,
            report_text: item.report_text === undefined ? null : item.report_text
          }
        }
      }, {
        $set: {
          'treasures.$.flagged': true,
          'treasures.$.report_text': after
        }
      });
      if (changed) return;
    }

    throw new Meteor.Error('busy', 'The treasure changed meanwhile, try again');
  },
  'unReportTreasure': function unReportTreasure(treasureId) {
    var _findItem10 = findItem('treasures', treasureId),
        land = _findItem10.land;

    requireCommunityRole('manager', land); // the owner or moderators (community/access.js, #18)

    Land.update({
      'treasures.id': treasureId
    }, {
      $set: {
        'treasures.$.flagged': false
      }
    });
  },
  'deleteTreasure': function deleteTreasure(treasureId) {
    var _findItem11 = findItem('treasures', treasureId),
        land = _findItem11.land,
        item = _findItem11.item;

    requireCommunityRole('manager', land, item.createdBy); // the owner, moderators or its author (community/access.js, #18)

    Land.update({
      id: land.id
    }, {
      $pull: {
        treasures: {
          id: treasureId
        }
      }
    });
  },
  // an answer to a pledge: anyone logged in, as the pledge page offers, once per pledge (each answer adds to the
  // score), an amount from 0 (a "no") up to what the pledge page allows, and why (#18)
  'addAmountPledge': function addAmountPledge(pledgeId, amount, reason) {
    check(amount, Match.Where(function (value) {
      return (typeof value === 'number' || typeof value === 'string') && isFinite(Number(value)) && Number(value) >= 0 && Number(value) <= MAX_PLEDGE_AMOUNT;
    }));
    check(reason, Match.Where(function (value) {
      return typeof value === 'string' && value.length <= 2000;
    }));
    findItem('pledges', pledgeId);
    var userId = Meteor.userId();
    var record = {
      id: genUuid(),
      userid: userId,
      amount: Number(amount),
      reason: reason,
      createdAt: new Date()
    }; // one update, and only while this user has no answer in it yet

    var changed = Land.update({
      pledges: {
        $elemMatch: {
          id: pledgeId,
          'data.userid': {
            $ne: userId
          }
        }
      }
    }, {
      $inc: {
        'pledges.$.amount': Number(amount),
        'pledges.$.number': 1
      },
      $push: {
        'pledges.$.reasons': reason,
        'pledges.$.data': record
      }
    });
    if (!changed) throw new Meteor.Error('already-answered', 'You answered this pledge already');
    var amountInc = KV.findOne({
      'key': 'FUND_PLEDGE'
    }).value;
    Meteor.users.update({
      _id: userId
    }, {
      $inc: {
        'profile.score': amountInc
      }
    });
  },
  'reportComment': function reportComment(commentId, threadId) {
    var _findComment = findComment(commentId, threadId),
        land = _findComment.land,
        comment = _findComment.comment;

    var user = requireCommunityRole('member', land); // members only, never their own (community/access.js, #18)

    if (comment.createdBy === user._id) throw new Meteor.Error('not-authorized', 'No report on your own comment');
    updateComment(commentId, threadId, function (at) {
      return {
        $set: _defineProperty({}, at + '.flagged', true)
      };
    });
  },
  'deleteComment': function deleteComment(commentId, threadId) {
    var _findComment2 = findComment(commentId, threadId),
        land = _findComment2.land,
        comment = _findComment2.comment;

    requireCommunityRole('manager', land, comment.createdBy); // owner, moderators or its author (community/access.js, #18)

    Land.update({
      'threads.id': threadId
    }, {
      $pull: {
        'threads.$.comments': {
          id: commentId
        }
      }
    });
  },
  'unReportComment': function unReportComment(commentId, threadId) {
    var _findComment3 = findComment(commentId, threadId),
        land = _findComment3.land;

    requireCommunityRole('manager', land); // owner or moderators (community/access.js, #18)

    updateComment(commentId, threadId, function (at) {
      return {
        $set: _defineProperty({}, at + '.flagged', false)
      };
    });
  },
  // the votes: a member's, never on their own comment, each once; taking your own vote back only needs a login
  'upVoteComment': function upVoteComment(commentId, threadId) {
    var _findComment4 = findComment(commentId, threadId),
        land = _findComment4.land,
        comment = _findComment4.comment;

    var user = requireVoter(land, comment);
    updateComment(commentId, threadId, function (at) {
      return {
        $addToSet: _defineProperty({}, at + '.upVotes', user._id),
        $pull: _defineProperty({}, at + '.downVotes', user._id)
      };
    });
  },
  'removeUpVoteComment': function removeUpVoteComment(commentId, threadId) {
    var userId = requireLogin();
    findComment(commentId, threadId);
    updateComment(commentId, threadId, function (at) {
      return {
        $pull: _defineProperty({}, at + '.upVotes', userId)
      };
    });
  },
  'downVoteComment': function downVoteComment(commentId, threadId) {
    var _findComment5 = findComment(commentId, threadId),
        land = _findComment5.land,
        comment = _findComment5.comment;

    var user = requireVoter(land, comment);
    updateComment(commentId, threadId, function (at) {
      return {
        $addToSet: _defineProperty({}, at + '.downVotes', user._id),
        $pull: _defineProperty({}, at + '.upVotes', user._id)
      };
    });
  },
  'removeDownVoteComment': function removeDownVoteComment(commentId, threadId) {
    var userId = requireLogin();
    findComment(commentId, threadId);
    updateComment(commentId, threadId, function (at) {
      return {
        $pull: _defineProperty({}, at + '.downVotes', userId)
      };
    });
  },
  'addComment': function addComment(threadId, comment) {
    check([threadId, comment], [String]);
    requireCommunityRole('member', findThread(threadId).land); // members only (community/access.js, #18)
    // UUID

    var s = [];
    var hexDigits = '0123456789abcdef';

    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }

    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010

    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    Land.update({
      'threads.id': threadId
    }, {
      // $push : { threads: { [day]: { "$[index]": score } } }
      $push: {
        'threads.$.comments': {
          id: uuid,
          text: cleanHtml(comment),
          createdBy: Meteor.userId(),
          createdByName: Meteor.user().profile.name,
          createdAt: new Date(),
          upVotes: [],
          downVotes: []
        }
      } // $push: {
      //     'threads.${index}.comments': {
      //         id: uuid,
      //         text:comment,
      //         createdBy: Meteor.userId(),
      //         createdAt: new Date(),
      //     }
      // }

    } // { arrayFilters: [ { index: index } ] },
    ); //Update score

    var amountInc = KV.findOne({
      'key': 'ADD_DISCUSSION_COMMENT'
    }).value;
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $inc: {
        'profile.score': amountInc
      }
    });
  },
  'addVote': function addVote(pollId, value) {
    check(value, Match.Integer); // anyone logged in, as the poll page offers (community/access.js, #18)

    var _findItem12 = findItem('polls', pollId),
        land = _findItem12.land,
        poll = _findItem12.item; // (an older poll may have two answers with one number: the vote goes to the first, as it always did)


    var index = (poll.options || []).findIndex(function (option) {
      return option.value === value;
    });
    if (index === -1) throw new Meteor.Error('not-found', 'No such answer');
    var user = Meteor.user();
    var vote = {
      id: genUuid(),
      value: value,
      createdBy: user._id,
      createdByName: user.profile.name,
      createdAt: new Date()
    }; // one vote per poll: one update, and only while this user has none in it yet

    var changed = Land.update({
      id: land.id,
      polls: {
        $elemMatch: {
          id: pollId,
          'options.votes.createdBy': {
            $ne: user._id
          }
        }
      }
    }, {
      $push: _defineProperty({}, 'polls.$.options.' + index + '.votes', vote)
    });
    if (!changed) throw new Meteor.Error('already-voted', 'You voted on this poll already');
  },
  'user.setLocale': function userSetLocale(locale) {
    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        updatedAt: new Date(),
        'profile.locale': locale
      }
    });
  },
  'user.update': function userUpdate(profile, newUsername) {
    if (!profile || !isAcceptedName(profile.name)) throw new Meteor.Error('invalid-name', 'The name must be text of at most ' + NAME_MAX_LENGTH + ' characters');
    var oldUsername = Meteor.user().emails[0].address; // console.log('oldUsername', oldUsername)
    // console.log('newUsername', newUsername)
    // console.log('test', oldUsername !== newUsername)

    if (oldUsername !== newUsername) {
      // console.log('GGGGGGGGGGGGGGGGGGGGGGOOOD')
      Accounts.addEmail(this.userId, newUsername);
      Accounts.removeEmail(this.userId, oldUsername); // Accounts.setUsername(Meteor.userId(), newUsername)
    }

    Meteor.users.update({
      _id: Meteor.userId()
    }, {
      $set: {
        updatedAt: new Date(),
        'profile.email': newUsername,
        'profile.name': profile.name ? profile.name.trim() : profile.name // 'profile.city': profile.city,
        // 'profile.number': profile.number,
        // 'profile.centerCoordinates': profile.centerCoordinates,
        // 'profile.pdokv2': profile.pdokv2,
        // 'profile.pdokv2_query': profile.pdokv2_query

      }
    });
  },
  'error.gen': function errorGen(message) {
    console.log('ERROR server');
    var a = 1 / 0;
    console.log(a); // Meteor.call('error.gen')

    throw new Error('Meteorr SERVER test error: ' + new Date().getTime());
  },
  'log': function log(message) {
    console.log('HALLO2');
    console.log(message);
  },

  /*    sendEmail (to, from, subject, text) {
          // Make sure that all arguments are strings.
          check([to, from, subject, text], [String])
           // Let other method calls from the same client start running, without
          // waiting for the email sending to complete.
          this.unblock()
           console.log('EMAIL ADRESS')
          console.log(to)
          console.log('EMAIL SUBJECT')
          console.log(subject)
          console.log('EMAIL TEXT')
          console.log(text)
           const bcc = 'friends@greenmapper.org'
           Email.send({ to, from, subject, text })
      },*/
  sendTestTemplateMail: function sendTestTemplateMail(emailAddress, id) {
    // the admin's template screen only (#249)
    if (!isAdmin(Meteor.user())) throw new Meteor.Error('not-authorized', 'Admin only');
    if (typeof emailAddress !== 'string' || !emailAddress.trim()) throw new Meteor.Error('no-address', 'Fill in a test e-mail address');
    check(id, String);
    console.log('sendTestTemplateMail', emailAddress);
    var template = KV.findOne({
      'id': id
    });
    if (!template || !template.value) throw new Meteor.Error('not-found', 'No such template');
    var body = template.value.body || '';
    (template.value.params || []).forEach(function (param) {
      body = replaceAll(body, param, param + '_>REPLACED<'); //body = body.replace(param, param+'_>REPLACED<')
    });
    console.log(body);
    sendHtmlEmail(emailAddress, 'friends@greenmapper.org', template.value.title, body);
  }
});